var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-form", { ref: "suitInfo", attrs: { model: _vm.suit } }, [
        _c("div", { staticClass: "content-caption dashed" }, [
          _c("span", [_vm._v("基本信息")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "simple-form" }, [
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("套装系统编号")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.suit.no))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("套装名称")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.suit.name))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("所属机构")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.suit.retailerShopName))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("机构标签")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.suit.retailerShopTagName || "无"))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("套内资产数量")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.suit.devcQuantity))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("最新套装变更时间")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.suit.ts))])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content-caption dashed" }, [
          _c("span", [_vm._v("主资产信息")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "simple-form" }, [
          _vm.suit.imageUrl != null && _vm.suit.imageUrl != ""
            ? _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("资产图片")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("img", {
                    staticStyle: { width: "100px" },
                    attrs: { src: _vm.suit.imageUrl }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("资产描述全称")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.suit.devcTitle))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("系统编号")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c(
                "a",
                {
                  staticClass: "swb-btn-link",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.gotoShopDevice(_vm.suit.devcTmpNo)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.suit.devcTmpNo))]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("分类")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.suit.devcCatName))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("分类分组")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.getDevcGroupNameByCatId(_vm.suit.devcCatId)))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("品牌")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.suit.devcBrandName))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("规格")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.suit.devcModelSpec))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("责任部门")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.suit.departName))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("责任人")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.suit.principalName))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("备注")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _c("span", [_vm._v(_vm._s(_vm.suit.memo))])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content-caption dashed" }, [
          _c("span", [_vm._v("附属资产信息")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-layout" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.suit.shopDeviceSuitAccList, border: "" }
              },
              [
                _c("el-table-column", {
                  attrs: { align: "left", width: "100", label: "图片" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          rows.row.imageUrl != null && rows.row.imageUrl != ""
                            ? _c("img", { attrs: { src: rows.row.imageUrl } })
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "devcTitle",
                    label: "名称",
                    align: "left",
                    width: "150",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "devcTmpNo",
                    label: "系统编号",
                    width: "250",
                    align: "left",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c("span", [
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    _vm.gotoShopDevice(rows.row.devcTmpNo)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(rows.row.devcTmpNo))]
                            )
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "devcCatName",
                    label: "分类",
                    width: "150",
                    align: "left",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "devcGroup",
                    label: "分类分组",
                    align: "left",
                    "min-width": "130",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.getDevcGroupNameByCatId(rows.row.devcCatId)
                              )
                            )
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "devcBrandName",
                    label: "品牌",
                    width: "150",
                    align: "left",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "devcModelSpec",
                    label: "规格",
                    width: "150",
                    align: "left",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "departName",
                    label: "责任部门",
                    width: "100",
                    align: "left",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "principalName",
                    label: "责任人",
                    width: "100",
                    align: "left",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "memo", label: "备注" }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-404464b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-404464b8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/ShopDeviceSuitDetail.vue
// module id = 2285
// module chunks = 0